import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './trackFormSelectOverrides.css';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const appRoot = googleClientId ? (
  <GoogleOAuthProvider clientId={googleClientId}>
    <App />
  </GoogleOAuthProvider>
) : (
  <App />
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <AppErrorBoundary>
    {appRoot}
  </AppErrorBoundary>
);
